import { type LinearCstic } from "../Linear/models";
import { CSTIC_SCHMIERANSCHLUSS_NAME } from "../Linear/constants";

const CSTIC_SCHMIERANSCHLUSS_SHOW_MORE_FIELDS_VALUES = ["L", "R"];
const CSTIC_SCHMIERANSCHLUSS_SHOW_CONNECTOR_VALUES = ["L", "R", "BL", "BR"];

export function isSchmierPositionCsticVisible(cstics: Dict<LinearCstic>) {
  const schmierCsticValue = cstics[CSTIC_SCHMIERANSCHLUSS_NAME]?.value;
  return schmierCsticValue && CSTIC_SCHMIERANSCHLUSS_SHOW_MORE_FIELDS_VALUES.includes(schmierCsticValue);
}

export function isSchmierAuswahlCsticVisible(cstics: Dict<LinearCstic>) {
  const schmierCsticValue = cstics[CSTIC_SCHMIERANSCHLUSS_NAME]?.value;
  return schmierCsticValue && CSTIC_SCHMIERANSCHLUSS_SHOW_CONNECTOR_VALUES.includes(schmierCsticValue);
}

export function isSchmierDegreeCsticVisible(cstics: Dict<LinearCstic>) {
  const schmierCsticValue = cstics[CSTIC_SCHMIERANSCHLUSS_NAME]?.value;
  return schmierCsticValue && CSTIC_SCHMIERANSCHLUSS_SHOW_MORE_FIELDS_VALUES.includes(schmierCsticValue);
}
